<template>
    <main class="w-full flex-col justify-center gap-2">
        <div
            v-if="active === true"
            class="mx-auto grow pb-6"
        >
            <AlertBox
                v-if="active === true"
                :state="config.state.send ? 'success' : 'danger'"
                :icon="MdiEmail"
                :title="config.state.send ? t('notifyOk') : t('notifyError')"
            >
                <p
                    v-if="config.state.send === false"
                    class="py-1 text-sm"
                >
                    {{ t('previewEmailNotSend') }}
                    <br />{{ config.preset.fileName }}.{{ config.preset.extension }}
                </p>
                <p
                    v-if="config.state.send === true"
                    class="py-1 text-sm"
                >
                    {{ t('previewEmailSend') }}
                    <br />{{ config.preset.fileName }}.{{ config.preset.extension }}
                </p>
            </AlertBox>
        </div>
        <div
            v-if="active === true"
            class="mx-auto grow pb-6"
        >
            <AlertBox
                v-if="active === true"
                :state="config.state.download ? 'success' : 'danger'"
                :icon="MdiEmail"
                :title="config.state.download ? t('notifyOk') : t('notifyError')"
            >
                <p
                    v-if="config.state.download === false"
                    class="py-1 text-sm"
                >
                    {{ t('previewFileNotCreated') }}
                    <br />{{ config.preset.fileName }}.{{ config.preset.extension }}
                </p>
                <p
                    v-if="config.state.download === true"
                    class="py-1 text-sm"
                >
                    {{ t('previewFileCreated') }}
                    <br />{{ config.preset.fileName }}.{{ config.preset.extension }}
                </p>
            </AlertBox>
        </div>
        <div class="mx-auto grow border border-gray-400 p-4">
            <iframe
                v-if="active === true"
                :src="`${config.preset.contentPrefix}${config.raw}`"
                class="min-h-96 w-full border-none"
                title="Preview frame"
            />
        </div>
    </main>
</template>
<script setup>
    import AlertBox from '../ui/AlertBox.vue';
    import { MdiEmail } from 'materialdesignicons-vue3/icons/';

    defineExpose({
        name: 'EmailPreview',
    });

    const props = defineProps({
        config: {
            type: Object,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
    });
    const config = props.config;
    const active = props.active;
</script>
